<script setup>
import Odd from '../Odd.vue'
import JackpotOdd from '../JackpotOdd.vue'
import HShirt from '../HShirt.vue'
import AShirt from '../AShirt.vue'
import { timestampToTime, safeTranslate, timestampToDayMonthString } from '@/helpers'
import { defineEmits, defineProps, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n';

const { t, te } = useI18n()
const router = useRouter()
const assetsUrl = import.meta.env.VITE_ASSETS_URL
const homeKitError = ref(false)
const awayKitError = ref(false)

const props = defineProps({
  event: Object,
  selections: Array,
  market: [String, Number],
})

const emit = defineEmits(['jackpot-odd'])

const goToDetails = () => {
  router.push(`/pre/${props.event.i}`)
}

const onJackpotOdd = (odd) => {
  emit('jackpot-odd', { odd, eventId: props.event.i })
}
const regionTranslation = (event) => { 
    return safeTranslate('regions', event.ri, t, te , event.rn)
}
</script>

<template>
  <div class="ev-Box" v-if="event">
    <div class="px-2 xl:px-7 my-2 flex gap-1 border-r border-neutral-600/50" @click="goToDetails">
      <div class="overflow-hidden">
        <p class="event-det">
            <img :src="`/loc/${event.ri}.svg`" class="w-4 h-4 rounded-full"/>
            {{ regionTranslation(event) }} - {{event.cn}}
        </p>
        <div class="ev-Teams" v-if="event.o == 'false' || event.o == false">
          
          <div class="flex items-center gap-1">
            <div v-if="!homeKitError">
                <img
                  v-if="event?.hi"
                  :src="`${assetsUrl}/teams/${event.hi}.png`"
                  class="w-[11px] h-[11px] object-contain min-w-[11px]"
                  @error="homeKitError = true"
                />
              </div>
              <div v-else class="w-[11px] h-[11px] min-w-[11px]">
                <HShirt />
              </div>
            <p class="ev-Participant">{{ event.h }}</p>
          </div>

          <div class="flex items-center gap-1">
            <div v-if="!awayKitError">
              <img
                v-if="event?.ai"
                :src="`${assetsUrl}/teams/${event.ai}.png`"
                class="w-[11px] h-[11px] object-contain min-w-[11px]"
                @error="awayKitError = true"
              />
            </div>
            <div v-else class="w-[11px] h-[11px] min-w-[11px]">
              <AShirt />
            </div>
            <p class="ev-Participant">{{ event.a }}</p>
          </div>

        </div>

        <div class="ev-Teams" v-else>
          <p class="ev-Participant">{{ $t('events.outrightf') }}</p>
        </div>

        <div class="ev-Time">
          <p class="text-[11px] text-[var(--color-primary5)] opacity-75">
              {{ timestampToDayMonthString(event.t) }} {{ timestampToTime(event.t) }}
          </p>
        </div>

      </div>
    </div>

    <div>
    <ul class="list-none flex h-full" v-if="selections?.length">
        <li class="flex-1">
        <JackpotOdd
            :odd="selections?.[0]?.o?.find(s => s.n === '1')"
           :eventId="event.i"
            @jackpot-odd="onJackpotOdd"
        />
        </li>

        <li class="flex-1">
        <JackpotOdd
            :odd="selections[0]?.o?.find(s => s.n === 'X')"
            :eventId="event.i"
            @jackpot-odd="onJackpotOdd"
        />
        </li>

        <li class="flex-1">
        <JackpotOdd
            :odd="selections[0]?.o?.find(s => s.n === '2')"
            :eventId="event.i"
            @jackpot-odd="onJackpotOdd"
        />
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped>
.ev-Box {
  @apply grid grid-cols-2;
}
.ev-Box:not(:last-of-type) {
  @apply border-b;
}
.ev-Time {
  @apply flex items-center;
}
.ev-Teams:hover .ev-Participant {
  color: var(--color-primary5);
}
.ev-Participant {
  @apply text-[13px] font-bold text-white flex items-center gap-1;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ev-Teams {
  @apply flex-1 overflow-hidden whitespace-nowrap cursor-pointer;
}
ul {
  list-style-type: none !important;
  margin: 0;
  padding: 0;
}
.event-det{
    @apply text-xs text-gray-400 flex items-start gap-1 pb-1
}
</style>
